import { createSlice } from "@reduxjs/toolkit";
import { LogType } from "./Types";

type initialStateType = {
  globalLogs: LogType[];
  status: {
    globalLogsLoading: boolean;
  };
};

const initialState: initialStateType = {
  globalLogs: [],
  status: {
    globalLogsLoading: false,
  },
};

const globalLogsSlice = createSlice({
  name: "global_logs",
  initialState: initialState,
  reducers: {
    setGlobalLogs: (state, action) => {
      state.globalLogs = action.payload;
    },
    setGlobalLogsLoading: (state, action) => {
      state.status.globalLogsLoading = action.payload;
    },
  },
});

export const globalLogsSliceReducer = globalLogsSlice.reducer;
export const globalLogsSliceAction = globalLogsSlice.actions;
